import _toConsumableArray from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as nls from '../../../nls.js';
import { Emitter } from '../../../base/common/event.js';
import { Registry } from '../../registry/common/platform.js';
import * as types from '../../../base/common/types.js';
import { Extensions as JSONExtensions } from '../../jsonschemas/common/jsonContributionRegistry.js';
export var Extensions = {
  Configuration: 'base.contributions.configuration'
};
export var allSettings = {
  properties: {},
  patternProperties: {}
};
export var applicationSettings = {
  properties: {},
  patternProperties: {}
};
export var machineSettings = {
  properties: {},
  patternProperties: {}
};
export var machineOverridableSettings = {
  properties: {},
  patternProperties: {}
};
export var windowSettings = {
  properties: {},
  patternProperties: {}
};
export var resourceSettings = {
  properties: {},
  patternProperties: {}
};
export var resourceLanguageSettingsSchemaId = 'vscode://schemas/settings/resourceLanguage';
var contributionRegistry = Registry.as(JSONExtensions.JSONContribution);

var ConfigurationRegistry = /*#__PURE__*/function () {
  function ConfigurationRegistry() {
    _classCallCheck(this, ConfigurationRegistry);

    this.overrideIdentifiers = new Set();
    this._onDidSchemaChange = new Emitter();
    this._onDidUpdateConfiguration = new Emitter();
    this.defaultValues = {};
    this.defaultLanguageConfigurationOverridesNode = {
      id: 'defaultOverrides',
      title: nls.localize('defaultLanguageConfigurationOverrides.title', "Default Language Configuration Overrides"),
      properties: {}
    };
    this.configurationContributors = [this.defaultLanguageConfigurationOverridesNode];
    this.resourceLanguageSettingsSchema = {
      properties: {},
      patternProperties: {},
      additionalProperties: false,
      errorMessage: 'Unknown editor configuration setting',
      allowTrailingCommas: true,
      allowComments: true
    };
    this.configurationProperties = {};
    this.excludedConfigurationProperties = {};
    contributionRegistry.registerSchema(resourceLanguageSettingsSchemaId, this.resourceLanguageSettingsSchema);
  }

  _createClass(ConfigurationRegistry, [{
    key: "registerConfiguration",
    value: function registerConfiguration(configuration) {
      var validate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      this.registerConfigurations([configuration], validate);
    }
  }, {
    key: "registerConfigurations",
    value: function registerConfigurations(configurations) {
      var _this = this;

      var validate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var properties = [];
      configurations.forEach(function (configuration) {
        properties.push.apply(properties, _toConsumableArray(_this.validateAndRegisterProperties(configuration, validate))); // fills in defaults

        _this.configurationContributors.push(configuration);

        _this.registerJSONConfiguration(configuration);
      });
      contributionRegistry.registerSchema(resourceLanguageSettingsSchemaId, this.resourceLanguageSettingsSchema);

      this._onDidSchemaChange.fire();

      this._onDidUpdateConfiguration.fire(properties);
    }
  }, {
    key: "registerOverrideIdentifiers",
    value: function registerOverrideIdentifiers(overrideIdentifiers) {
      var _iterator = _createForOfIteratorHelper(overrideIdentifiers),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var overrideIdentifier = _step.value;
          this.overrideIdentifiers.add(overrideIdentifier);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this.updateOverridePropertyPatternKey();
    }
  }, {
    key: "validateAndRegisterProperties",
    value: function validateAndRegisterProperties(configuration) {
      var validate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var scope = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 3;
      scope = types.isUndefinedOrNull(configuration.scope) ? scope : configuration.scope;
      var propertyKeys = [];
      var properties = configuration.properties;

      if (properties) {
        for (var key in properties) {
          if (validate && validateProperty(key)) {
            delete properties[key];
            continue;
          }

          var property = properties[key]; // update default value

          this.updatePropertyDefaultValue(key, property); // update scope

          if (OVERRIDE_PROPERTY_PATTERN.test(key)) {
            property.scope = undefined; // No scope for overridable properties `[${identifier}]`
          } else {
            property.scope = types.isUndefinedOrNull(property.scope) ? scope : property.scope;
          } // Add to properties maps
          // Property is included by default if 'included' is unspecified


          if (properties[key].hasOwnProperty('included') && !properties[key].included) {
            this.excludedConfigurationProperties[key] = properties[key];
            delete properties[key];
            continue;
          } else {
            this.configurationProperties[key] = properties[key];
          }

          if (!properties[key].deprecationMessage && properties[key].markdownDeprecationMessage) {
            // If not set, default deprecationMessage to the markdown source
            properties[key].deprecationMessage = properties[key].markdownDeprecationMessage;
          }

          propertyKeys.push(key);
        }
      }

      var subNodes = configuration.allOf;

      if (subNodes) {
        var _iterator2 = _createForOfIteratorHelper(subNodes),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var node = _step2.value;
            propertyKeys.push.apply(propertyKeys, _toConsumableArray(this.validateAndRegisterProperties(node, validate, scope)));
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }

      return propertyKeys;
    }
  }, {
    key: "getConfigurationProperties",
    value: function getConfigurationProperties() {
      return this.configurationProperties;
    }
  }, {
    key: "registerJSONConfiguration",
    value: function registerJSONConfiguration(configuration) {
      var _this2 = this;

      var register = function register(configuration) {
        var properties = configuration.properties;

        if (properties) {
          for (var key in properties) {
            _this2.updateSchema(key, properties[key]);
          }
        }

        var subNodes = configuration.allOf;

        if (subNodes) {
          subNodes.forEach(register);
        }
      };

      register(configuration);
    }
  }, {
    key: "updateSchema",
    value: function updateSchema(key, property) {
      allSettings.properties[key] = property;

      switch (property.scope) {
        case 1
        /* APPLICATION */
        :
          applicationSettings.properties[key] = property;
          break;

        case 2
        /* MACHINE */
        :
          machineSettings.properties[key] = property;
          break;

        case 6
        /* MACHINE_OVERRIDABLE */
        :
          machineOverridableSettings.properties[key] = property;
          break;

        case 3
        /* WINDOW */
        :
          windowSettings.properties[key] = property;
          break;

        case 4
        /* RESOURCE */
        :
          resourceSettings.properties[key] = property;
          break;

        case 5
        /* LANGUAGE_OVERRIDABLE */
        :
          resourceSettings.properties[key] = property;
          this.resourceLanguageSettingsSchema.properties[key] = property;
          break;
      }
    }
  }, {
    key: "updateOverridePropertyPatternKey",
    value: function updateOverridePropertyPatternKey() {
      var _iterator3 = _createForOfIteratorHelper(this.overrideIdentifiers.values()),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var overrideIdentifier = _step3.value;
          var overrideIdentifierProperty = "[".concat(overrideIdentifier, "]");
          var resourceLanguagePropertiesSchema = {
            type: 'object',
            description: nls.localize('overrideSettings.defaultDescription', "Configure editor settings to be overridden for a language."),
            errorMessage: nls.localize('overrideSettings.errorMessage', "This setting does not support per-language configuration."),
            $ref: resourceLanguageSettingsSchemaId
          };
          this.updatePropertyDefaultValue(overrideIdentifierProperty, resourceLanguagePropertiesSchema);
          allSettings.properties[overrideIdentifierProperty] = resourceLanguagePropertiesSchema;
          applicationSettings.properties[overrideIdentifierProperty] = resourceLanguagePropertiesSchema;
          machineSettings.properties[overrideIdentifierProperty] = resourceLanguagePropertiesSchema;
          machineOverridableSettings.properties[overrideIdentifierProperty] = resourceLanguagePropertiesSchema;
          windowSettings.properties[overrideIdentifierProperty] = resourceLanguagePropertiesSchema;
          resourceSettings.properties[overrideIdentifierProperty] = resourceLanguagePropertiesSchema;
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      this._onDidSchemaChange.fire();
    }
  }, {
    key: "updatePropertyDefaultValue",
    value: function updatePropertyDefaultValue(key, property) {
      var defaultValue = this.defaultValues[key];

      if (types.isUndefined(defaultValue)) {
        defaultValue = property.default;
      }

      if (types.isUndefined(defaultValue)) {
        defaultValue = getDefaultValue(property.type);
      }

      property.default = defaultValue;
    }
  }]);

  return ConfigurationRegistry;
}();

var OVERRIDE_PROPERTY = '\\[.*\\]$';
export var OVERRIDE_PROPERTY_PATTERN = new RegExp(OVERRIDE_PROPERTY);
export function overrideIdentifierFromKey(key) {
  return key.substring(1, key.length - 1);
}
export function getDefaultValue(type) {
  var t = Array.isArray(type) ? type[0] : type;

  switch (t) {
    case 'boolean':
      return false;

    case 'integer':
    case 'number':
      return 0;

    case 'string':
      return '';

    case 'array':
      return [];

    case 'object':
      return {};

    default:
      return null;
  }
}
var configurationRegistry = new ConfigurationRegistry();
Registry.add(Extensions.Configuration, configurationRegistry);
export function validateProperty(property) {
  if (OVERRIDE_PROPERTY_PATTERN.test(property)) {
    return nls.localize('config.property.languageDefault', "Cannot register '{0}'. This matches property pattern '\\\\[.*\\\\]$' for describing language specific editor settings. Use 'configurationDefaults' contribution.", property);
  }

  if (configurationRegistry.getConfigurationProperties()[property] !== undefined) {
    return nls.localize('config.property.duplicate', "Cannot register '{0}'. This property is already registered.", property);
  }

  return null;
}